import React, { useState } from "react";

import { Input } from "../../../common/u1/Input";
import { CountrySelect } from "../../../common/u1/CountrySelect";
import { EditDialog } from "./EditDialog";
import { DialogBreadcrumb } from "./DialogBreadcrumb";
import { manualCompany, validateManualCompany } from "./ownershipSearch";

/* Step 3 — name a business the search cannot find. */
export const OwnershipAddCompanyModal = ({ onClose, onBack, onAdd }) => {
  const [name, setName] = useState("");
  const [country, setCountry] = useState("");
  const [errors, setErrors] = useState({});

  const submit = () => {
    const found = validateManualCompany({ name, country });
    setErrors(found);
    if (Object.keys(found).length > 0) return;
    onAdd?.(manualCompany({ name, country, state: "" }));
  };

  return (
    <EditDialog
      title=""
      onClose={onClose}
      ctaLabel="Add Business Name"
      onSubmit={submit}
      width={540}
    >
      <DialogBreadcrumb
        prev="Select business"
        next="Add Business Name"
        onBack={onBack}
      />

      <Input
        wrapperClassName="mt-4"
        label="Business Name"
        id="u1-manual-company-name"
        value={name}
        onChange={(e) => {
          setName(e.target.value);
          setErrors((prev) => ({ ...prev, name: "" }));
        }}
        error={errors.name}
        placeholder="Enter Business Name"
      />

      <CountrySelect
        className="mt-3.5"
        label="Country"
        labelVariant="field"
        id="u1-manual-company-country"
        value={country}
        onChange={(c) => {
          setCountry(c?.code);
          setErrors((prev) => ({ ...prev, country: "" }));
        }}
        error={errors.country}
        placeholder="Select a country"
      />
    </EditDialog>
  );
};

export default OwnershipAddCompanyModal;
